<mat-form-field [formGroup]="select" class="width">
  <mat-label *ngIf="this.label !== undefined">{{this.label}}</mat-label>
  <mat-select [disabled]="this.disabled" single formControlName="privilegeSelect" (selectionChange)="this.selectedOption($event.value)" [required]="this.isRequired()">
    <mat-option *ngFor="let option of this.showingOptions" [value]="option" >
      {{option.value}}
    </mat-option>
  </mat-select>
</mat-form-field>
